<template>
  <header class="header j-container-box-shadow">
    <div class="j-container">
      <div class="logo">
        <a @click="handleLogoClick">
          <img class="logo-img" src="@/assets/images/logo.svg" alt="Logo" />
        </a>
      </div>
      <HeaderNav></HeaderNav>
      <div class="utility">
        <ul class="utility-list">
          <li v-if="!!userInfo" class="utility-list-item">
            <AvatarIcon class="icon" />
            <span>{{ userInfo && userInfo.email }}</span>
          </li>

          <a-divider
            v-if="!!userInfo"
            type="vertical"
            style="margin: 0 20px; height: 26px"
          />

          <li
            v-if="!!userInfo"
            class="utility-list-item logout"
            @click="handleLogout"
          >
            <LogoutIcon class="icon" />

            <span>{{ $t('nav.logout') }}</span>
          </li>

          <a-divider
            v-if="!!userInfo"
            type="vertical"
            style="margin: 0 20px; height: 26px"
          />

          <li class="utility-list-item" :title="$t('language')">
            <a-select @change="handleLangChange" :value="lang">
              <a-select-option
                v-for="lang in langs"
                :key="lang.id"
                :value="lang.locale"
                >{{ lang.localeName }}
              </a-select-option>
              <template #suffixIcon><SelectArrowIcon type="arrow"/></template>
            </a-select>
          </li>

          <li>
            <div class="out-link">
              <a
                href="https://www.facebook.com/CNJEV"
                target="_blank"
                title="facebook"
                ><FacebookIcon :style="{ fontSize: '24px'}"
              /></a>
              <a
                href="https://www.linkedin.com/company/77766311/admin"
                target="_blank"
                title="linkedin"
                ><LinkedInIcon :style="{ fontSize: '24px'}"
              /></a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState, mapActions } from 'vuex';
import HeaderNav from './HeaderNav.vue';
import SelectArrowIcon from '@/components/icons/SelectArrowIcon.vue';
import AvatarIcon from '@/components/icons/AvatarIcon.vue';
import LogoutIcon from '@/components/icons/LogoutIcon.vue';
import { logout } from '@/api/apis';
import FacebookIcon from '@/components/icons/FacebookIcon.vue';
import LinkedInIcon from '@/components/icons/LinkedInIcon.vue';

export default defineComponent({
  name: 'Header',
  components: {
    HeaderNav,
    SelectArrowIcon,
    AvatarIcon,
    LogoutIcon,
    FacebookIcon,
    LinkedInIcon
  },
  computed: {
    ...mapState(['lang', 'langs', 'userInfo'])
  },
  methods: {
    ...mapActions(['setLang', 'changeAndSetLangMessage', 'clearLoginInfo']),
    handleLangChange(value: string) {
      this.setLang(value);
      this.changeAndSetLangMessage(value);
    },
    async handleLogout() {
      await logout();
      await this.clearLoginInfo();

      this.$router.replace('/home');
    },
    handleLogoClick() {
      if (!this.userInfo) {
        this.$router.push('/home');
      } else {
        this.$router.push('/vehicle');
      }
    }
  }
});
</script>

<style scoped lang="scss">
.header {
  padding-left: 20px;
  padding-right: 20px;
  background-color: white;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
}

.out-link a {
  margin-right: 10px;
}

.j-container {
  display: flex;
  align-items: center;
}

.logo {
  height: 50px;
  margin-right: 24px;

  .logo-img {
    height: inherit;
  }
}

.utility {
  margin-left: auto;

  .utility-list {
    display: flex;
    align-items: center;

    .logout {
      cursor: pointer;
    }

    .utility-list-item {
      margin-left: 10px;
      display: flex;
      align-items: center;

      .icon {
        margin-right: 10px;
      }
    }
  }

  ::v-deep {
    .ant-select {
      .ant-select-selector {
        border: none;
      }
      .ant-select-selection-item {
        font-size: 12px;
        color: #666666;
        letter-spacing: 0.09px;
        text-transform: uppercase;
      }

      .ant-select-arrow {
        color: #999;
      }
    }
  }
}
</style>
